import React from 'react';

const Page404 = () => <h1>Page404</h1>

export default Page404
